module.exports = __webpack_public_path__ + "img/user.99449532.svg";